import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import FeaturesGrid from "../components/FeaturesGrid";
import CtaBanner from "../components/CtaBanner";
import Icon from "../components/Icon";
import HowItWorks from "../components/HowItWorks";

function Features() {
  return (
    <>
      <PageHero
        eyebrow="Features"
        title="The features that set it apart"
        subtitle="Combining selfie verification with location information provides a more transparent attendance process than a basic check-in / check-out system."
      />

      <section className="section">
        <div className="container">
          <FeaturesGrid />
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <HowItWorks />
          {/* <div className="section-cta-link section-cta-link--center">
            <Link to="/features/how-it-works" className="link-arrow">
              View the full employee &amp; admin flow <Icon name="arrow" size={14} />
            </Link>
          </div> */}
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default Features;
